import DataTable from "../../../../../components/DataTable";

const Applications = ({ results }) => {
  function extractProductName(cpeString) {
    if (cpeString.startsWith("cpe:/a:")) {
      // Confirm it's an application CPE
      let parts = cpeString.split(":");
      return parts.length > 3 ? parts[3] : null;
    }
    return cpeString; // Return string if it's not a valid application CPE
  }

  const columns = [
    {
      id: "port",
      accessorFn: (row) => `${row.name ?? ""} ${row.value ?? ""}`, // combine both for search
      header: () => <span>Application</span>,
      width: "50%",
      cell: ({ row }) => (
        <span>
          {" "}
          {row.original.name} - {extractProductName(row.original.value)}
        </span>
      ),
    },
    {
      accessorKey: "ip",
      header: () => <span>Host</span>,
      width: "50%",
      cell: ({ row }) => <span>{row.original.ip}</span>,
    },
  ];

  console.log(columns);

  return (
    <div>
      {results && results.length > 0 && (
        <DataTable columns={columns} data={results} />
      )}
      {results && results.length === 0 && (
        <div className=" h-[45vh] w-full flex justify-center flex-col items-center text-center">
          <p className=" font-semibold text-xl">There are no results</p>
        </div>
      )}
    </div>
  );
};

export default Applications;
